module.exports = __webpack_public_path__ + "static/media/86.727f987.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/86.wav
// module id = SSvj
// module chunks = 0